import $ from 'jquery';
import slick from 'slick-slider';
import respImg from './responsiveImages';
import lazy from './lazyLoad';

var lightBoxCount = 0;

function updateCaption(slider,index,animate) {
    var slide;
    if(index !== undefined) {
        slide = slider.find(`.slick-slide[data-slick-index="${index}"]`);
    } else {
        slide = slider.find('.slick-slide.slick-current');
    }
    var modal = slider.closest('.lightbox-modal');
    var caption = modal.find('[data-lightbox-caption]');
    var captionContainer = caption.closest('.container');
    var captionWrap = captionContainer.parent();
    var sliderWrap = slider.parent();
    var captionText = slide.find('[data-caption]').data('caption');
    var d = $('<div>').html(captionText);
    if(caption.html()== d.html()) return;
    modal.toggleClass('lightbox-modal--no-caption', captionText == '');
    if(!animate) {
        captionWrap.stop();
        caption.html(captionText);
        sliderWrap.css('paddingBottom',captionContainer.outerHeight());
    } else {
        captionWrap.stop().animate({opacity:0},150,function() {
            caption.html(captionText);
            var h = captionContainer.outerHeight();
            sliderWrap.css('paddingBottom',h);
            captionWrap.animate({opacity:1},150);
        });
    }
    slider.slick('setPosition');
}

function updateCount(slider) {
    var modal = slider.closest('.lightbox-modal');
    var count = modal.find('[data-lightbox-count]');
    if(!count.length) return;
    var num = slider.find('.slick-slide:not(.slick-cloned)').length;
    var current = slider.slick('slickCurrentSlide') + 1;
    count.html(`${current}/${num}`);
}

function preloadImages(slider) {
    var slide = slider.find('.slick-slide.slick-active');
    slide.lazyLoad();
    slide.prev().lazyLoad();
    slide.next().lazyLoad();
}

function openLightbox(id, initialSlide) {

    var modal = (typeof id == 'string') ? $('#' + id) : id;
    if(!modal.length) return;
    if(!modal.attr('id')) {
        lightBoxCount++;
        modal.attr('id','lb-' + lightBoxCount);
    }
    modal.addClass('show');
    $('body').addClass('has-modal');
    setTimeout(function() {
        modal.addClass('active');
    },50);
    resizeLightbox(modal);
    var modalSlider = modal.find('[data-lightbox-slider]');
    if(!modalSlider.hasClass('slick-slider')) {
        modalSlider.on('init',function() {
            respImg.initEl(modalSlider,true);
            preloadImages(modalSlider);
            setTimeout(function() {
                updateCaption(modalSlider);
                updateCount(modalSlider);
            },100);
        });
        modalSlider.on('afterChange',function(event,slick,currentSlide) {
            updateCaption(modalSlider,currentSlide,true);
            updateCount(modalSlider);
            preloadImages(modalSlider);
        });
        modalSlider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            initialSlide: initialSlide || 0,
            lazyLoad: false,
            nextArrow: "<span><i class='fas fa-arrow-right'></i></span>",
            prevArrow: "<span><i class='fas fa-arrow-left'></i></span>",
            dots: false,
        });
    } else {
        modalSlider.slick('slickGoTo',initialSlide || 0,true);
    }

    window.location.hash = modal.attr('id');
}

function closeLightbox( modal ) {
    if(!modal) {
        modal = $('.lightbox-modal:visible').first();
    }
    var modalSlider = modal.find('[data-lightbox-slider]');
    modal.one('transitionend',function() {
        modal.removeClass('show');
    });
    modal.removeClass('active');
    $('body').removeClass('has-modal');
    if(window.history && window.history.pushState) {
        window.history.pushState('',document.title,window.location.pathname);
    } else {
        window.location.hash = '/';
    }
}

function resizeLightbox(modal) {
    var slider = modal.find('[data-lightbox-slider]');
    var sliderWrap = slider.parent();
}

$(function() {

    $(document).on('keydown',function(event) {
        var slider = $('.lightbox-modal .slick-slider:visible');
        if(!slider.length) return;
        if(event.keyCode == 37) {
            //left arrow
            slider.slick('slickPrev');
        } else if(event.keyCode == 39) {
            //right arrow
            slider.slick('slickNext');
        } else if(event.keyCode == 27) {
            var modal = slider.closest('.lightbox-modal');
            closeLightbox(modal);
        }
    });

    $(document).on('click','[data-lightbox-close]', function() {
        var modal = $(this).closest('.lightbox-modal');
        closeLightbox(modal);
    });

    $(document).on('click','[data-lightbox]',function(e) {
        var id = $(this).data("lightbox");
        if(!id)return;
        e.preventDefault();
        var allElements = $( `[data-lightbox="${id}"]` );
        var index = allElements.index( $(this) );
        openLightbox( id, index );
    });

    $(window).on('resize',function() {
        var modal = $('.lightbox-modal.active');
        if(modal.length) {
            resizeLightbox( modal );
        }
    });

    $(window).on('hashchange',function() {
        var h = window.location.hash.replace('#','');
        var box = h ? $('.lightbox-modal[id="' + h + '"]') : [];
        if(box.length) {
            if(!box.hasClass('show')) {
                openLightbox(box);
            }
        } else {
            box = $('.lightbox-modal.active');
            if(box.length) {
                closeLightbox(box);
            }
        }
    }).trigger('hashchange');

});

export default {
    init: function(config) {
        if(!config.modal || !config.triggers) {
            return;
        }
        var modal = config.modal || false;
        var triggers = config.triggers || false;
        triggers.on('click',function() {
            var index = 0;
            if(config.getIndex) {
                index = config.getIndex($(this));
            }
            openLightbox(modal,index);
        });
    },
    open: openLightbox,
}
